export default __webpack_public_path__ + "static/media/Banner-solucoes-img.74ce2c47.jpg";